var _path, _path2, _path3, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFaqs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.3077 5H6.69231C6.24348 5 5.81303 5.1783 5.49567 5.49567C5.1783 5.81303 5 6.24348 5 6.69231V21.0769C5 21.5258 5.1783 21.9562 5.49567 22.2736C5.81303 22.5909 6.24348 22.7692 6.69231 22.7692H10.0769V27L15.3569 22.7692H25.3077C25.7565 22.7692 26.187 22.5909 26.5043 22.2736C26.8217 21.9562 27 21.5258 27 21.0769V6.69231C27 6.24348 26.8217 5.81303 26.5043 5.49567C26.187 5.1783 25.7565 5 25.3077 5Z",
    fill: "#F7BFCC",
    stroke: "#000001",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4609 11.7689C13.4609 11.2669 13.6098 10.7761 13.8887 10.3586C14.1677 9.94119 14.5641 9.61583 15.028 9.4237C15.4918 9.23157 16.0022 9.1813 16.4946 9.27925C16.987 9.37719 17.4394 9.61896 17.7944 9.97397C18.1494 10.329 18.3911 10.7813 18.4891 11.2737C18.587 11.7661 18.5368 12.2765 18.3446 12.7404C18.1525 13.2042 17.8271 13.6007 17.4097 13.8796C16.9922 14.1585 16.5015 14.3074 15.9994 14.3074V15.1535",
    fill: "#F7BFCC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4609 11.7689C13.4609 11.2669 13.6098 10.7761 13.8887 10.3586C14.1677 9.94119 14.5641 9.61583 15.028 9.4237C15.4918 9.23157 16.0022 9.1813 16.4946 9.27925C16.987 9.37719 17.4394 9.61896 17.7944 9.97397C18.1494 10.329 18.3911 10.7813 18.4891 11.2737C18.587 11.7661 18.5368 12.2765 18.3446 12.7404C18.1525 13.2042 17.8271 13.6007 17.4097 13.8796C16.9922 14.1585 16.5015 14.3074 15.9994 14.3074V15.1535",
    stroke: "#000001",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 19,
    r: 1,
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaqs);
export default __webpack_public_path__ + "static/media/faqs.8f5050a5b99afc49f5d8a2bc6d2bfe07.svg";
export { ForwardRef as ReactComponent };